import api from 'services/api';
import config from 'config';
import React, {useCallback, useEffect, useState} from 'react';
import {formatDate} from 'components/formatos';
import {getestabelecimentos} from 'functions/gettabconfig';

function APROVAAVALIACAO() {
    const [idestabelecimento] = useState(getestabelecimentos(0));
    const [avaliacoes, setAvaliacoes] = useState([]);

    const refreshAvaliacoes = useCallback(() => {
        api.get(`${config.ESTABELECIMENTOS_AVALIACAO}?id=${idestabelecimento}&aprovado=N`)
            .then(response => {
                setAvaliacoes(response.data)
            })
            .catch(err => console.log(err));
    }, [idestabelecimento]);

    const aprovaravaliacoes = (id, index) => {
        api.post(`${config.ADM_ESTABELECIMENTOS_AVALIACAO}/aprovar/${id}`,
            { ies_aprovacao: 'S', den_resposta: avaliacoes[index].den_resposta })
            .then(response => {
                refreshAvaliacoes();
            })
    };

    const deletaravaliacoes = (id) => {
        api.delete(`${config.ADM_ESTABELECIMENTOS_AVALIACAO}/aprovar/${id}`)
            .then(response => {
                refreshAvaliacoes();
            })
    };
    const setValor = (id, index, valor) => {
        const newAvaliacoes = [...avaliacoes];
        newAvaliacoes[index].den_resposta = valor;
        setAvaliacoes(newAvaliacoes);
    }

    useEffect(() => {
        refreshAvaliacoes();
    }, [refreshAvaliacoes]);


    return (
        <div>
            <h2 className="section-title">Aprovação de Avaliações</h2>
            
            {avaliacoes.length === 0 ? (
                <div className="modern-empty-state text-center p-5 bg-card-admin rounded-4 mt-4">
                    <div className="empty-state-icon mb-3 opacity-25">
                        <i className="fas fa-check-double fa-4x text-success"></i>
                    </div>
                    <h4 className="text-muted fw-bold">Tudo em dia!</h4>
                    <p className="text-muted mb-0">Nenhuma avaliação pendente para aprovação no momento.</p>
                </div>
            ) : (
                <div className="row g-4 mt-2">
                    {avaliacoes.map((item, index) => (
                        <div className="col-12 col-lg-6" key={item.id_avaliacao}>
                            <div className="avaliacao-admin-card bg-card-admin rounded-4 p-4 h-100 d-flex flex-column transition-all">
                                <div className="d-flex justify-content-between align-items-start mb-3">
                                    <div className="d-flex align-items-center gap-3">
                                        <div className="avatar-circle bg-primary text-white d-flex align-items-center justify-content-center fw-bold shadow-sm" style={{ width: '45px', height: '45px', borderRadius: '50%', fontSize: '1.2rem' }}>
                                            {item.nomeusuario ? item.nomeusuario.charAt(0).toUpperCase() : 'U'}
                                        </div>
                                        <div>
                                            <div className="fw-bold text-dark">{item.nomeusuario}</div>
                                            <div className="text-muted small">
                                                <i className="far fa-clock me-1 text-primary"></i>
                                                {formatDate(item.datahora)}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="rating-stars text-warning">
                                        {[...Array(5)].map((_, i) => (
                                            <i key={i} className={`${i < item.qtd_estrelas ? 'fas' : 'far'} fa-star`}></i>
                                        ))}
                                    </div>
                                </div>
                                
                                <div className="avaliacao-content mb-4 flex-grow-1 p-3 bg-light rounded-3 border-start border-4 border-primary">
                                    <p className="mb-0 text-dark italic" style={{fontStyle: 'italic'}}>"{item.den_avaliacao || 'Sem descrição'}"</p>
                                </div>
                                
                                <div className="avaliacao-response mb-4">
                                    <label className="form-label small fw-bold text-muted mb-2">Sua Resposta (Opcional)</label>
                                    <textarea 
                                        className="form-control rounded-3 border-2 shadow-none"
                                        rows="2"
                                        placeholder="Digite uma resposta para o cliente..."
                                        value={item.den_resposta || ''}
                                        onChange={(e) => setValor(item.id_avaliacao, index, e.target.value)}
                                        style={{fontSize: '0.9rem'}}
                                    />
                                </div>
                                
                                <div className="avaliacao-actions d-flex gap-2 mt-auto">
                                    <button 
                                        type="button" 
                                        className="btn btn-success flex-grow-1 d-flex align-items-center justify-content-center gap-2 py-2 rounded-3 fw-bold"
                                        onClick={() => aprovaravaliacoes(item.id_avaliacao, index)}
                                    >
                                        <i className="fas fa-check"></i>
                                        <span>Aprovar</span>
                                    </button>
                                    <button 
                                        type="button" 
                                        className="btn btn-outline-danger d-flex align-items-center justify-content-center px-3 rounded-3"
                                        onClick={() => deletaravaliacoes(item.id_avaliacao)}
                                        title="Deletar Avaliação"
                                    >
                                        <i className="fas fa-trash-alt"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default APROVAAVALIACAO;